/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const CommonSavedFilterCreateUpdateDTOTypeEnum = {
    Keyword: 'KEYWORD',
    Store: 'STORE',
    Search: 'SEARCH',
    ProductStaging: 'PRODUCT_STAGING',
    Inventory: 'INVENTORY'
};
/**
 * @export
 */
export const CommonSavedFilterCreateUpdateDTOTargetMarketEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * Check if a given object implements the CommonSavedFilterCreateUpdateDTO interface.
 */
export function instanceOfCommonSavedFilterCreateUpdateDTO(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
export function CommonSavedFilterCreateUpdateDTOFromJSON(json) {
    return CommonSavedFilterCreateUpdateDTOFromJSONTyped(json, false);
}
export function CommonSavedFilterCreateUpdateDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'type': json['type'] == null ? undefined : json['type'],
        'targetMarket': json['targetMarket'] == null ? undefined : json['targetMarket'],
        'filter': json['filter'] == null ? undefined : json['filter'],
        'autoDelete': json['autoDelete'] == null ? undefined : json['autoDelete'],
        'periodHoursDelete': json['periodHoursDelete'] == null ? undefined : json['periodHoursDelete'],
        'maxProductsPerRunDelete': json['maxProductsPerRunDelete'] == null ? undefined : json['maxProductsPerRunDelete'],
        'autoAddToInventory': json['autoAddToInventory'] == null ? undefined : json['autoAddToInventory'],
        'periodHoursAdd': json['periodHoursAdd'] == null ? undefined : json['periodHoursAdd'],
        'maxProductsPerRunAdd': json['maxProductsPerRunAdd'] == null ? undefined : json['maxProductsPerRunAdd'],
        'autoAddToProductStaging': json['autoAddToProductStaging'] == null ? undefined : json['autoAddToProductStaging'],
    };
}
export function CommonSavedFilterCreateUpdateDTOToJSON(json) {
    return CommonSavedFilterCreateUpdateDTOToJSONTyped(json, false);
}
export function CommonSavedFilterCreateUpdateDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'type': value['type'],
        'targetMarket': value['targetMarket'],
        'filter': value['filter'],
        'autoDelete': value['autoDelete'],
        'periodHoursDelete': value['periodHoursDelete'],
        'maxProductsPerRunDelete': value['maxProductsPerRunDelete'],
        'autoAddToInventory': value['autoAddToInventory'],
        'periodHoursAdd': value['periodHoursAdd'],
        'maxProductsPerRunAdd': value['maxProductsPerRunAdd'],
        'autoAddToProductStaging': value['autoAddToProductStaging'],
    };
}
